// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import Api from '@/components/Api/Api'
import router from '@/router'
import Ionic from '@ionic/vue'

import '@ionic/core/css/ionic.bundle.css'
import '../public/ionicons/css/ionicons.min.css'

Vue.config.productionTip = false
Vue.use(Ionic)
console.info("Bienvenido a Vueonic Framework. Producto diseñado por Alberto Herrera <alherrera42@gmail.com>")
/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')